import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import {
    getAnalyticsEventLabel,
    useSaveForLater,
} from "web/react/hooks/use-save-for-later/use-save-for-later";
import { openEmailCaptureOverlay } from "web/redux/ducks/email-capture-overlay";
import withReduxProvider from "web/react/redux-provider";
import SaveForLater from "./save-for-later";

const basePropTypes = {
    className: PropTypes.string,
    cta: PropTypes.string,
    pageSource: PropTypes.oneOf(["pdp", "feed", "oos"]).isRequired,
    productId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["icon", "small", "normal", "stockAlert"]).isRequired,
    features: PropTypes.object,
};

export function AnonymousSFLButton({
    className,
    cta,
    openEmailCaptureOverlay,
    pageSource,
    productId,
    type,
    features,
}) {
    let trackClick = useClickTracker(
        "save_for_later",
        "add_item",
        getAnalyticsEventLabel(pageSource),
        false
    );

    function handleClick(event) {
        trackClick(event);

        openEmailCaptureOverlay({
            productId: productId,
            captureType: `signup_${pageSource}_save`, // signup_pdp_save or signup_feed_save
        });
    }

    return (
        <SaveForLater
            className={className}
            cta={cta}
            isSaved={false}
            onClick={handleClick}
            type={type}
            features={features}
        />
    );
}

AnonymousSFLButton.propTypes = {
    ...basePropTypes,
    openEmailCaptureOverlay: PropTypes.func.isRequired,
};

const _AnonymousSFLButton = withReduxProvider(
    connect(null, { openEmailCaptureOverlay })(AnonymousSFLButton)
);

export function AuthenticatedSFLButton({
    className,
    cta,
    initialIsSaved,
    pageSource,
    productId,
    type,
    features,
}) {
    let [isSaved, isLoading, toggleSaved] = useSaveForLater(productId, pageSource, initialIsSaved);
    if (isSaved == null) {
        isSaved = false;
    }
    return (
        <SaveForLater
            className={className}
            cta={cta}
            isSaved={isSaved}
            isSaving={isLoading}
            onClick={toggleSaved}
            type={type}
            features={features}
        />
    );
}

AuthenticatedSFLButton.propTypes = {
    ...basePropTypes,
    initialIsSaved: PropTypes.bool,
};

function SaveForLaterButton({ isLoggedIn, ...props }) {
    if (isLoggedIn) {
        return <AuthenticatedSFLButton {...props} />;
    } else {
        return <_AnonymousSFLButton {...props} />;
    }
}

export default SaveForLaterButton;

SaveForLaterButton.propTypes = {
    ...basePropTypes,
    isLoggedIn: PropTypes.bool.isRequired,
};

SaveForLaterButton.defaultProps = {
    type: "normal",
};
